<template>
  <el-dialog :title="dialogTitle" :visible.sync="makeVisible" custom-class="dialogBox" :lock-scroll="false" :before-close="DialogClose" top="10vh">
    <div class="like_box" v-if="condition">
      <div class="like_img">
        <img :src="list.Imgs[0]+'?imageView2/2/w/200'" />
      </div>
      <div class="slide_txt color_333">
        <p class="line_txt3">{{list.Title}}</p>
        <div class="price" v-if="list.ReleaseType!=1">{{ $t('base.price') }}: <span> {{list.Currency}} {{showPrice(list)}}</span></div>
      </div>
    </div>
    <div class="price_btn color_333">
      <div class="btn text_blue1" @click="goto">{{ $t('base.goToShoppingCart') }} ></div>
    </div>
  </el-dialog>
</template>
<script>
import qs from 'qs'
import { formatAmount } from "@/api/public";
export default {
  name: '',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      dialogTitle: '',
    }
  },
  props: {
    makeVisible: Boolean,
    list: {},
    shopCart:{},
    condition:{},
    userInfo: {},
  },
  watch: {},
  filters: {},
  mounted(){
    this.dialogTitle=this.shopCart.num+" "+(this.shopCart.num>1?this.$t('base.items'):this.$t('base.item'))+` ${this.$t('base.addedToCart')}`
    
  },
  created() {
  },
  methods: {
    showPrice(obj){
      let that = this;
      if(obj.Status==1){
        return formatAmount(that.condition.Price)
      }
      if(obj.Status==2){
        return that.condition.ShowPrice?formatAmount(that.condition.Price):'???'
      }
    },
    formatAmount(obj){
      return formatAmount(obj)
    },
    goto() {
      let that = this;
      that.DialogClose()
          that.$router.push({
            path: '/pay/cart'
          })
      // let data = that.shopCart
      // this.$post(this.$interface.SetShopCart, data).then(res => {
      //   if (res.result != 0) {
      //     that.DialogClose()
      //     that.$router.push({
      //       path: '/pay/cart'
      //     })
      //   } else {
      //     this.$message({
      //       type: 'error',
      //       message: res.msg
      //     });
      //   }
      // })
    },
    DialogClose() {
      this.$emit('getDialog', false)
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.like_box {
  display: flex;
}
.line_txt3{
  font-weight: normal;
}

.like_img {
  width: 88px;
  height: 88px;
  background-color: #f0f0f0;
  border-radius: 4px;
}

.like_img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.slide_txt {
  width: 345px;
  position: relative;
}

.price_btn {
  text-align: right;
}

.price_btn>div {
  margin-top: 20px;
}

.price{
  position: absolute;
  bottom: 0;
}

.price span {
  font-size: 18px;
}

.btn {
  display: inline-block;
  padding: 9px 12px;
  border: 1px solid #5F6DAE;
  border-radius: 4px;
  /* color: #5F6DAE; */
  cursor: pointer;
}


</style>



// WEBPACK FOOTER //
// src/components/dialog/cartdialog.vue